import { compose, lifecycle, withProps } from 'recompose';

import withLoading from '../../../../../common/withLoading';

const ReviewStepContainer = compose(
  lifecycle({
    async componentDidMount() {
      this.props.validateOrder();
    },
  }),
  withProps(props => ({
    showLoading: props.validating,
  })),
  withLoading,
);

export default ReviewStepContainer;
